import React from "react";
import { Button, Dialog } from "@mui/material"; // DialogActions, DialogContent, DialogContentText, Typography removed by Bearer Web Developer
import { useAppState } from "../../states/app-state";
import { observer } from "mobx-react-lite";
import { useThemeMode } from "../../states/contexts/theme"; // added by Bearer Web Developer
import styles from "./CheckServerRunningStates.module.scss"; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer

const CheckServerRunningStates: React.FC = () => {
    const appState = useAppState();
    const [error, setError] = React.useState(false);
    React.useEffect(() => {
        (async () => {
            if (!appState.serverChecked) {
                try {
                    await appState.checkServer();
                } catch (err) {
                    setError(true);
                }
            }
        })();
    }, [appState]);

    return (
        <>
            <NoCloudFunctions />
            <NoWebApp />
            {error && <ServerErrorPopup />}
        </>

    )
}
export default CheckServerRunningStates;

const NoCloudFunctions = observer(() => {

    const appState = useAppState();
    const noCloudFunctions = appState.noCloudFunctions;

    const handleClick = () => {
        window.location.replace(noCloudFunctions!.url);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <Dialog open={!!noCloudFunctions} PaperProps={{ style: { borderRadius: "10px" } }}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "10px",
                        backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
                    },
                    classes: { root: styles.root }
                },
            }}>
            <div className={styles.popup_content} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <div className={styles.text}>
                    <h5>{noCloudFunctions?.text || "Ops, its seems that there is a connectivity issue"}</h5>
                </div>
                <div className={''}>
                    {/* modified by Bearer Web Developer start */}
                    {noCloudFunctions?.buttonAction &&
                        <Button className={styles.button_action} onClick={handleClick}>
                            {/* <span>{noCloudFunctions?.buttonAction}</span> */}  {/* commented by Bearer Web Developer */}
                            <span>Learn More</span> {/* added by Bearer Web Developer */}
                        </Button>
                    }
                    {/* modified by Bearer Web Developer end */}
                </div>
            </div>
        </Dialog>
    )
    // modified by Bearer Web Developer end
})


const NoWebApp = observer(() => {

    const appState = useAppState();
    const noWebApp = appState.noWebApp;

    const handleClick = () => {
        window.location.replace(noWebApp!.url);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <Dialog open={!!noWebApp} slotProps={{
            paper: {
                sx: {
                    borderRadius: "10px",
                    backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
                },
                classes: { root: styles.root }
            },
        }}>
            <div className={styles.popup_content} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <div className={styles.text}>
                    <h5>{noWebApp?.text}</h5>
                </div>
                <div className={''}>
                    <Button className={styles.button_action} onClick={handleClick}>
                        {/* <span>{noWebApp?.buttonAction}</span> */}  {/* commented by Bearer Web Developer */}
                        <span>Learn More</span> {/* added by Bearer Web Developer */}
                    </Button>
                </div>
            </div>
        </Dialog>
    )
    // modified by Bearer Web Developer end
})



const ServerErrorPopup: React.FC = () => {

    const handleClick = () => {
        window.location.reload()
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <Dialog open={true}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "10px",
                        backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
                    },
                    classes: { root: styles.root }
                },
            }}>
            <div className={styles.popup_content} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <div className={styles.text}>
                    <h5>The service is temporarily unavailable, please try later.</h5>
                </div>
                <div className={''}>
                    <Button className={styles.button_action} onClick={handleClick}>
                        <span>Retry</span>
                    </Button>
                </div>
            </div>
        </Dialog>
    )
    // modified by Bearer Web Developer end
}